import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

export function useCustomPanelStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: {
        "& .ms-Panel-scrollableContent": {
          height: `100%`,
          overflow: `hidden`
        },
        "& .ms-Panel-commands": {
          zIndex: 1
        },
        "& .ms-Panel-content": {
          height: `calc(100% - 54px)`,
          paddingBottom: `10px`,
          overflow: `hidden`
        },
        "& .ms-Panel-navigation > button": {
          marginRight: `20px`,
          marginTop: `4px`,
          background: `transparent`
        }
      }
    }),
    []
  );
}
